<template>
  <v-card
    class="mb-1"
    flat
    tile
    outlined
  >
    <v-card-subtitle>
      区間{{ section.section }}
    </v-card-subtitle>
    <v-card-text>
      <!-- 収集運搬業者 -->
      <v-row>
        <v-col cols="12" md="5">
          <validation-provider
            v-slot="{ errors }"
            :vid="`transport_id-${section.section}`"
            :name="`収集運搬業者`"
            class="requiredMark"
            rules="required"
          >
            <v-autocomplete
              v-model="section.transport_id"
              :error-messages="errors"
              :items="transports"
              :disabled="!editable"
              clearable
              dense
              hide-details="auto"
              label="収集運搬業者"
              outlined
              persistent-placeholder
              style="font-size: 90%"
            >
              <template v-slot:item="slotProps" >
                <v-chip
                  :title="slotProps.item.subscriber_number"
                  color="#e0ffff"
                  drak
                  label
                  small
                >
                  {{ slotProps.item.subscriber_number }}
                </v-chip>&nbsp;
                {{slotProps.item.text}}&nbsp;
                <small class="text--disabled">{{slotProps.item.address | truncate(20)}} </small>
              </template>
            </v-autocomplete>
          </validation-provider>
          <div
            v-if="displayTransportAddress || displayTransportAttribute !== '-'"
            class="selection-meta mt-1"
          >
            <div>収運業者: {{ displayTransportAddress || '-' }}</div>
          </div>
        </v-col>
      </v-row>
      <!-- /収集運搬業者 -->

      <v-row>
        <!-- 運搬先 会社名 -->
        <v-col cols="12" md="5">
          <validation-provider
            v-slot="{ errors }"
            :name="`運搬先 会社名`"
            :rules="{
              required: true,
              traderDisposerMatcher: {
                disposerId: disposerId,
                lastRow: activeRow === section.section
                },
                intermediateSectionChecker: {
                  traders: traders,
                  lastRow: activeRow === section.section
                },
                generalDisposerSectionChecker: {
                  traders: traders,
                  section: section.section
                }
            }"
            :vid="`trader_id-${section.section}`"
            class="requiredMark"
          >
            <v-autocomplete
              v-model="section.trader_id"
              :error-messages="errors"
              :items="traders"
              :disabled="!editable"
              clearable
              dense
              hide-details="auto"
              label="運搬先 会社名"
              outlined
              placeholder="会社名で検索する"
              persistent-placeholder
              style="font-size: 90%"
              @change="traderChangeEvent"
            >
              <template v-slot:item="slotProps" >
                <v-chip
                  :title="slotProps.item.subscriber_number"
                  color="#e0ffff"
                  drak
                  label
                  small
                >
                  {{ slotProps.item.subscriber_number }}
                </v-chip>&nbsp;
                {{slotProps.item.text}}&nbsp;
                <small class="text--disabled">{{slotProps.item.address | truncate(20)}} </small>
              </template>
            </v-autocomplete>
          </validation-provider>
          <div
            v-if="displayTraderAddress || displayTraderAttribute !== '-'"
            class="selection-meta mt-1"
          >
            <div>{{ displayTraderAttribute }}: {{ displayTraderAddress || '-' }}</div>
          </div>
        </v-col>
        <!-- /運搬先 会社名 -->

        <!-- 事業場 -->
        <v-col cols="12" md="5">
          <validation-provider
            v-slot="{ errors }"
            :name="`運搬先 事業場名`"
            :rules="{
              required: true,
              traderLocationDisposerLocationMatcher: {
                traderId: section.trader_id,
                disposerId: disposerId, disposerLocationCode: disposerLocationCode,
                lastRow: activeRow === section.section
              }
            }"
            :vid="`trader_location_code-${section.section}`"
            class="requiredMark"
          >
            <v-select
              v-model="section.trader_location_code"
              :error-messages="errors"
              :items="traderLocations"
              :disabled="!editable"
              dense
              clearable
              hide-details="auto"
              label="事業場名"
              outlined
              persistent-placeholder
              style="font-size: 90%"
              @change="traderLocationChangeEvent"
            >
              <template v-slot:item="slotProps" >
                <v-chip
                  :title="slotProps.item.value"
                  color="#e0ffff"
                  drak
                  label
                  small
                >
                  {{ slotProps.item.value }}
                </v-chip>&nbsp;
                {{slotProps.item.text}}&nbsp;
                <small class="text--disabled">{{slotProps.item.address | truncate(20)}} </small>
              </template>
            </v-select>
          </validation-provider>
          <div
            v-if="displayTraderLocationAddress || displayTraderAttribute !== '-'"
            class="selection-meta mt-1"
          >
            <div>事業場: {{ displayTraderLocationAddress || '-' }}</div>
          </div>
        </v-col>
        <!-- /事業場 -->
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        :disabled="(section.section === 1) || !editable"
        color="error"
        @click="removeButtonClickEvent()"
      >
        <v-icon>mdi-trash-can</v-icon>
        &nbsp;削除&nbsp;
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: 'TransportRouteSectionForm',
  components: {},
  mixins: [],
  props: {
    section: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: () => null
    },
    activeRow: {
      type: Number,
      default: () => 0
    },
    transports: {
      type: Array,
      default: () => [],
    },
    traders: {
      type: Array,
      default: () => []
    },
    lastRow: {
      type: Boolean,
      default: () => false
    },
    disposerId: {
      type: Number,
      default: () => null,
    },
    disposerLocationCode: {
      type: String,
      default: () => null,
    },
    editable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      traderLocations: []
    }
  },
  computed: {
    selectedTransport () {
      return this.transports.find((item) => item.value === this.section.transport_id)
    },
    selectedTrader () {
      return this.traders.find((item) => item.value === this.section.trader_id)
    },
    selectedTraderLocation () {
      return this.traderLocations.find((item) => item.value === this.section.trader_location_code)
    },
    displayTransportAttribute () {
      return this.resolveTraderAttribute(this.selectedTransport)
    },
    displayTraderAttribute () {
      return this.resolveTraderAttribute(this.selectedTrader, this.section.trader_subscriber_type)
    },
    displayTransportAddress () {
      return (this.selectedTransport && this.selectedTransport.address) || this.section.transport_address || null
    },
    displayTraderAddress () {
      return (this.selectedTrader && this.selectedTrader.address) || this.section.trader_address || null
    },
    displayTraderLocationAddress () {
      return (this.selectedTraderLocation && this.selectedTraderLocation.address) || this.section.trader_location_address || null
    },
  },
  watch: {},
  created() {
    if (this.section.trader_location_code) {
      this.fetchTraderLocations({ id: this.section.trader_id }).then((content) => {
        this.traderLocations = content.locations
      })
    }
  },
  methods: {
    ...mapActions('DriverMasterSearchTraderLocation', {
      fetchTraderLocations: 'index',
    }),
    resolveTraderAttribute (item, fallbackType = null) {
      const target = item || {}

      const typeRaw = target.subscriber_type || target.trader_subscriber_type || target.trader_type_label || target.trader_type_name || target.attribute || target.search_type_label || target.search_type || target.type_name || target.type || fallbackType
      if (!typeRaw) return '-'

      const typeLabels = {
        transport: '収集運搬業者',
        transport_type: '収集運搬業者',
        trader: '処分業者',
        disposal: '処分業者',
        disposer_type: '処分業者',
        either: '収運・処分',
        GeneralWasteDisposal: '一般廃棄物処分業者',
        collection: '収集運搬業者'
      }
      return typeLabels[typeRaw] || typeRaw
    },
    /**
     * 運搬先事業者 チェンジイベント
     */
    traderChangeEvent () {
      this.traderLocations = []
      this.section.trader_location_code = null
      if (this.section.trader_id) {
        this.fetchTraderLocations({ id: this.section.trader_id }).then((content) => {
          this.traderLocations = content.locations
        })
      }
      this.traderLocationChangeEvent();
      if (this.activeRow === this.section.section) {
        this.$emit('changeCallback', this.section.trader_id)
      }
    },
    /**
     * 運搬先事業場 チェンジイベント
     */
    traderLocationChangeEvent () {
      console.log("traderLocationChangeEvent", this.section.trader_location_code)
      /** 最終ルートの運搬先 事業場名のチェンジイベントの伝達 */
      if (this.activeRow === this.section.section) {
        this.$emit('changeLocationCallback', this.section.trader_location_code)
      }
    },
    /**
     * 削除ボタン クリックイベント
     */
    removeButtonClickEvent () {
      this.section._destroy = true
      this.$emit('removeCallback')
    }
  }
}
</script>

<style scoped lang="scss">
.selection-meta {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
}

</style>
